import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogModule,
} from '@angular/material/dialog';
import { states } from '../../lib/states';
import { MaskService } from '../../services/mask.service';

import { CommonModule } from '@angular/common';
import { MaskitoDirective } from '@maskito/angular';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-calculate-income',
  templateUrl: './calculate-income-dialog.component.html',
  styleUrls: ['./calculate-income-dialog.component.scss'],
  imports: [
    FormsModule,
    CommonModule,
    MaskitoDirective,
    MatDialogModule,
    MatFormFieldModule,
    MatSelectModule,
    MatRadioModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
  ],
})
export class CalculateIncomeDialogComponent implements OnInit {
  dialogRef =
    inject<MatDialogRef<CalculateIncomeDialogComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);
  private mask = inject(MaskService);

  @ViewChild('calculateForm', { static: true }) private form: FormGroup;

  dollarMask = this.mask.dollarMaskSpecs();
  percentMask = this.mask.percentMaskSpecs();
  modalData = {
    AnnuityWizard: {
      PurchaseType: 1,
      AssessmentType: 1,
      Purpose: 1,
      StateOfIssue: null,
      InitialPremium: null,
      IncomeNeeded: null,
      JointProtection: null,
      AgeNeeded: null,
      RiskTolerance: 5,
      SolveType: 'F',
      QualifiedInitialPremium: 'N',
    },
    ClientEstimates: {
      Age: null,
    },
    SpouseEstimates: {
      Age: null,
      Gender: null,
    },
    ClientPerson: {
      Gender: null,
    },
    Client: {
      ID: 'TestCase',
    },
  };
  states = states;
  invalidAfterSubmit = false;

  ngOnInit(): void {
    if (this.data && typeof this.data !== 'undefined') {
      this.modalData = { ...this.data };
    }
  }

  cancel() {
    this.dialogRef.close('cancel');
  }

  save() {
    if (!this.form.valid) {
      Object.keys(this.form['form'].value).map(val => {
        if (!this.form['form'].value[val]) {
          this.invalidAfterSubmit = true;
          this.form['form'].controls[val].markAsTouched();
        }
      });
    }

    if (this.form.valid) {
      if (
        this.modalData.AnnuityWizard.SolveType === 'F' &&
        this.modalData.AnnuityWizard.InitialPremium
      ) {
        this.modalData.AnnuityWizard.IncomeNeeded = null;
        this.modalData.AnnuityWizard.InitialPremium = this.mask.removeMoneyMask(
          this.modalData.AnnuityWizard.InitialPremium
        );
      } else if (
        this.modalData.AnnuityWizard.SolveType === 'B' &&
        this.modalData.AnnuityWizard.IncomeNeeded
      ) {
        this.modalData.AnnuityWizard.InitialPremium = null;
        this.modalData.AnnuityWizard.IncomeNeeded = this.mask.removeMoneyMask(
          this.modalData.AnnuityWizard.IncomeNeeded
        );
      }
      this.dialogRef.close(this.modalData);
      this.dialogRef.afterClosed().subscribe(() => {
        this.dialogRef = null;
      });
    }
  }
}
